/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { OSKEnvironment } from './models/environment.model';

export const environment: OSKEnvironment = {
  title: 'OSKEY (Development)',
  version: '0.1.0',
  production: true,
  defaultLocale: 'fr_FR',
  firebaseConfig: {
    apiKey: 'AIzaSyCXHJfYWW2KowAC5vlfoUGjtXpEj4otTpg',
    authDomain: 'dev-oskey-io.firebaseapp.com',
    projectId: 'dev-oskey-io',
    databaseURL: 'https://dev-oskey-io.firebaseio.com',
    storageBucket: 'dev-oskey-io.appspot.com',
    messagingSenderId: '243629143238',
    appId: '1:243629143238:web:bde32e7aa78471af4a93c7',
    measurementId: 'G-GF8TMPH077'
  },
  reCaptcha: {
    siteCode: '6LdJZcsnAAAAAB4i64JlIPOxoLV2hkYHxPQX5mWv'
  },
  apple: {
    appBundleId: 'io.oskey.dev.app',
    appClipBundleIds: { acd: 'io.oskey.dev.app.AccessControlDevice' }
  },
  auth0: {
    domain: 'auth.dev.oskey.io',
    clientId: 'NUlPXIFcrtoIEN8W5NQupzOZQnW5eHCA'
  },
  locoApiKey: 'LOCO_WEB_API_KEY'
};
